import { Component } from '@angular/core';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './terms-of-use.component.html',
})
export class TermsOfUseComponent {
    constructor() {}
}
